// extracted by mini-css-extract-plugin
export default {"add-user-save-button-wrapper":"AddUser_add-user-save-button-wrapper__ezuLX","user-detail-label":"AddUser_user-detail-label__dCxD+"};